import { APP_NAME } from '../variables/GlobalVariables';

export function isWhiteLabelGma(): boolean {
  return (
    APP_NAME.toLowerCase().includes('gma') ||
    APP_NAME.toLowerCase().includes('gerermesaffaires')
  );
}
